export const useWakeLock = () => {
  let wakeLock: WakeLockSentinel | null = null

  const askWakeLockPermission = async () => {
    if (!('wakeLock' in navigator)) {
      return
    }

    try {
      wakeLock = await navigator.wakeLock.request('screen')
    } catch {
      return
    }
  }

  const releaseWakeLock = () => {
    wakeLock?.release()
  }

  return {
    askWakeLockPermission,
    releaseWakeLock
  }
}
